module.exports = __webpack_public_path__ + "img/onerq_landpage_960.66ddc1e0.png";